import React from 'react';

const NotFound = () => <></>;

export default NotFound;
